import React from 'react';
import { Box } from '@mui/material';

import { Typography } from '@occc-app/design-system';

import { State as LimitsState } from '../../Limits/redux';

const globalLimitSummary = (
  globalLimit: LimitsState['globalLimit'],
  requiresActivation: boolean,
): JSX.Element | null => {
  if (!globalLimit.active) {
    return null;
  }

  const verb = requiresActivation ? 'activation' : 'fulfillment';

  return (
    <Typography paragraph>
      In order to control our financial exposure, we'll limit the {verb} of this offer to{' '}
      <b>{globalLimit.limit}</b> total {verb}s across all of our membership base.
    </Typography>
  );
};

const membershipLimitSummary = (
  membershipLimit: LimitsState['membershipLimit'],
  requiresActivation: boolean,
): JSX.Element | null => {
  if (!membershipLimit.active) {
    return null;
  }

  const gerund = requiresActivation ? 'activating' : 'fulfilling';
  const verb = requiresActivation ? 'activation' : 'fulfillment';

  return (
    <Typography paragraph>
      In order to prevent abuse by a single membership over-
      {gerund} this offer, we'll limit each membership to <b>{membershipLimit.limit}</b> {verb}
      (s) each.
    </Typography>
  );
};

interface IProps {
  limits: LimitsState;
  requiresActivation: boolean;
}

export const LimitsSummary: React.FC<IProps> = ({ limits, requiresActivation }) => {
  const { globalLimit, membershipLimit } = limits;

  return (
    <Box>
      <Box>{globalLimitSummary(globalLimit, requiresActivation)}</Box>
      <Box>{membershipLimitSummary(membershipLimit, requiresActivation)}</Box>
    </Box>
  );
};
